export const growthBookFeatureFlags = {
  InventoryCsvValidationRules: 'Inventory-csv-validation-rules',
  productsCsvValidationRules: 'products-csv-validation-rules',
  languageList: 'language-list',
  AdminBffImageValidationRules: 'admin-bff-image-validation-rules',
  AdminTimezone: 'local-time-zone',
  AllowedCountriesForComboList: 'allowed-countries-for-combo-list',
}
